// 📁 src/data/loadArticles.js

function normalizeBlocks(article) {
  const raw = article.blocks || article.content?.blocks || article.content;

  if (Array.isArray(raw)) {
    return raw.map((block) => {
      if (block?.type === "model") block.type = "model3d"; // Legacy-Kompatibilität
      return block;
    });
  }

  if (typeof raw === "string") {
    return [
      {
        type: "paragraph",
        data: {
          text: raw.replace(/\n/g, "<br>"), // \n → <br> für Zeilenumbrüche
        },
      },
    ];
  }

  return [];
}

function slugify(title = "") {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

// 🎯 NEUE SIGNATUR: loadArticles kann jetzt optional einen slug erwarten
export async function loadArticles(slugToLoad = null) {
  try {
    // Wenn ein spezifischer Slug angefordert wird, laden wir nur DIESEN Artikel
    if (slugToLoad) {
      const articleRes = await fetch(`https://www.denisbitter.de/stage01/api/articles.php?slug=${slugToLoad}`);
      if (!articleRes.ok) {
        // Handle HTTP errors (e.g., 404 Not Found)
        console.error(`❌ Fehler beim Laden des spezifischen Artikels ${slugToLoad}: HTTP Status ${articleRes.status}`);
        return null; // Zeigt an, dass der Artikel nicht gefunden wurde
      }
      const json = await articleRes.json();

      // Überprüfe, ob die Antwort leer ist oder nicht das erwartete Format hat
      if (!json || Object.keys(json).length === 0) {
        console.warn(`⚠️ Artikel ${slugToLoad} wurde gefunden, aber die Antwort ist leer oder ungültig.`);
        return null;
      }

      return {
        ...json,
        blocks: normalizeBlocks(json),
        slug: slugify(json.title || "unbenannt"), // Stelle sicher, dass der Slug konsistent ist
      };
    }

    // Wenn kein Slug angefordert wird, laden wir weiterhin ALLE Artikel (für Übersichtsseiten)
    const res = await fetch("https://www.denisbitter.de/stage01/api/articles.php");
    const filenames = await res.json();

    const articlePromises = filenames.map(async (file) => {
      try {
        const articleRes = await fetch(`https://www.denisbitter.de/stage01/api/articles.php?slug=${file}`);
        const json = await articleRes.json();

        return {
          ...json,
          blocks: normalizeBlocks(json),
          slug: slugify(json.title || "unbenannt"),
        };
      } catch (err) {
        console.warn(`⚠️ Artikel ${file} konnte nicht geladen werden:`, err);
        return null;
      }
    });

    const all = await Promise.all(articlePromises);
    return all.filter(Boolean);

  } catch (e) {
    console.error("❌ Fehler beim Laden der Artikelliste oder des Artikels:", e);
    return slugToLoad ? null : []; // Fallback für spezifischen Artikel oder Liste
  }
}